import { GET_REVIEWS, GET_COUNTRY, GET_COUNTRIES } from '@/utils/store/actionTypes'
import { SET_COUNTRIES } from '@/utils/store/mutationTypes'
import { formatData } from '@/utils/apollo'
import { apolloClient } from '@/utils/store'
import CountryReviewSite from '@/apollo/country/CountryReviewSite.graphql'

export default {
  /**
   * Return customer review statistics.
   *
   * @param state
   * @returns {Promise<*>}
   */
  async [GET_REVIEWS] ({ state }) {
    const response = await apolloClient(this).query({
      query: CountryReviewSite,
      variables: {
        hostname: state.country
      }
    })

    return formatData(response)
  },
  async [GET_COUNTRY] (_, { country }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/countries/${country}`)

    return response
  },
  async [GET_COUNTRIES] ({ commit }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/countries`)

    const countriesData = response.reduce((acc, country) => {
      acc[country.code.toLowerCase()] = country

      return acc
    }, {})

    commit(SET_COUNTRIES, countriesData)

    return response
  }
}
